import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import SnackbarContent from '@material-ui/core/Snackbar'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import {FormattedMessage} from 'react-intl'
import {ContextConsumer} from '../Context'

const styles = theme => ({
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4,
  },
  paper: {
    width: '100%',
    maxWidth: 500,
    padding: 10,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'red',
  },
  messageText: {
    width: '100%',
    color: '#FFF',
    textAlign: 'center',
    padding: 10,
  },
  customPosition: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -275%)',
  },
})

const Notification = ({classes}) => (
  <ContextConsumer>
    {context => {
      return (
        <SnackbarContent
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          classes={{root: classes.customPosition}}
          open={context.notify}
          autoHideDuration={6000}
          onClose={context.handleCloseNotification}>
          <Paper classes={{root: classes.paper}}>
            <Typography
              align="center"
              className={classes.messageText}
              style={{color: 'white'}}
              variant="subheading">
              <FormattedMessage id={context.notifyMessage || 'noMatch'} />
            </Typography>
          </Paper>
        </SnackbarContent>
      )
    }}
  </ContextConsumer>
)

Notification.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Notification)



// WEBPACK FOOTER //
// ./src/components/Notification.js